import { render, staticRenderFns } from "./dispatchRepair.vue?vue&type=template&id=0329d910"
import script from "./dispatchRepair.vue?vue&type=script&lang=js"
export * from "./dispatchRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports